var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "变更版本",
        visible: _vm.changeVersionDialogVisible,
        width: "700px",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.changeVersionDialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "86px", "label-position": "left" } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-form-item", { attrs: { label: "固件名称" } }, [
                _vm._v(_vm._s(_vm.changeVersionRows.name)),
              ]),
              _c("el-form-item", { attrs: { label: "当前版本号" } }, [
                _vm._v(_vm._s(_vm.changeVersionRows.version)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("h3", [_vm._v("其他可用版本")]),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#F5F6F7" },
            size: "medium",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "version", label: "版本号" },
          }),
          _c("el-table-column", {
            attrs: { prop: "criticalVersionFlag", label: "关键版本" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.criticalVersionFlag
                      ? _c("span", [_vm._v("是")])
                      : _c("span", [_vm._v("否")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "operate" },
                        on: {
                          click: function ($event) {
                            return _vm.handleChoice(scope.row)
                          },
                        },
                      },
                      [_vm._v("选择")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [10, 20, 30, 40],
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }